// This replaces the standard pullquote markup on standard full width
// and custom full width articles with the updated editorial pullquote
// We're doing this though javascript because we have two different pull quote styling
// and the original style's markup is created through the ckeditor pull quote plugin
const quotes = $('.pullquote');
// Loop through all quotes in an article and replace their markup with the updated markup
quotes.each((i, quote) => {
  const quoteText = $('.pq-quote')[0].innerText;
  const speakerName = $('.pq-speaker')[i].innerText;
  const speakerTitle = $('.pq-speaker-title')[i].innerText;
  quote.classList.add('ed-pullquote');
  const openQuote = `<div class="ed-pullquote__symbol ed-pullquote__symbol--open">“</div>`; // eslint-disable-line quotes
  const closeQuote = `<div class="ed-pullquote__symbol ed-pullquote__symbol--close">”</div>`; // eslint-disable-line quotes
  const quoteBody = `<div class="ed-pullquote__container">
                        <p class="ed-pullquote__quote">${quoteText}</p>
                          <div class="ed-pullquote__person">
                            <p class="pq-speaker">${speakerName}</p>
                            <p class="pq-speaker-title">${speakerTitle}</p>
                          </div>
                    </div>`;
  quote.innerHTML = `${openQuote}${quoteBody}${closeQuote}`; // eslint-disable-line no-param-reassign
  // remove the old pullquote class
  $('.ed-pullquote')[i].classList.remove('pullquote');
});
